import Axios from "axios";
import { apiUrl } from "../environment";
import { handleAuthSessionHttpError } from "./axios";

function authRequestInterceptor(config) {
  config.headers.Accept = "application/json";
  return config;
}

export const axiosSAML = Axios.create({
  baseURL: apiUrl,
});

axiosSAML.interceptors.request.use(authRequestInterceptor);

axiosSAML.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => handleAuthSessionHttpError(error)
);
